import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginPage from './loginPage';

const CallbackPage: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const redirectPath = localStorage.getItem('workos_redirect_path');

    if (redirectPath && redirectPath !== '/callback') {
      navigate(redirectPath);
      localStorage.removeItem('workos_redirect_path');
    } else {
      navigate('/');
    }
  }, [navigate])
  
  return <LoginPage />;
};

export default CallbackPage;
